module.exports = __webpack_public_path__ + "fonts/x_ul-1.svg";